export default __webpack_public_path__ + "static/media/meal.d49e7857.png";